module.exports = __webpack_public_path__ + "static/media/businesslunch-catering-2.d86424d6.jpg";